/*
 * @Author: maomao
 * @Date: 2022-08-05 下午
 * @LastEditTime: 
 * 不是我喜欢的样子你都有，而是你的样子我都很喜欢
 */
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import bigscreen from '@/views/bigscreen/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'bigscreen',
      component: bigscreen
    },
    // {
    //   path: '/test',
    //   name: 'ThreeColorLight',
    //   component: ThreeColorLight
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js